import { render } from "./AddAccountDialog.vue?vue&type=template&id=31d8b619"
import script from "./AddAccountDialog.vue?vue&type=script&lang=js"
export * from "./AddAccountDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__